// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lr-1";
export var messageSideRight = "_lr-2";
export var orderLookupBubbleContainer = "_lr-0";
export var submitButton = "_lr-3";